/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sip_fd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FD Calculator — Fixed Deposit Maturity | Toolverse`)
};

const es_sip_fd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de FD — Vencimiento de Depósito Fijo | Toolverse`)
};

const de_sip_fd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FD-Rechner — Festgeld-Fälligkeitswert | Toolverse`)
};

const nl_sip_fd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FD-calculator — Vaste storting bij afloop | Toolverse`)
};

const fr_sip_fd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculatrice FD — Maturité Dépôt Fixe | Toolverse`)
};

const it_sip_fd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore FD — Scadenza Deposito Fisso | Toolverse`)
};

const pt_br2_sip_fd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de FD — Vencimento de Depósito Fixo | Toolverse`)
};

const pt_sip_fd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora FD — Maturidade de Depósito Fixo | Toolverse`)
};

const ja_sip_fd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FD計算機 — 定期預金満期 | Toolverse`)
};

const zh_sip_fd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`定期存款计算器——到期金额 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sip_fd_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sip_fd_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sip_fd_meta_title", locale)
	if (locale === "en") return en_sip_fd_meta_title(inputs)
	if (locale === "es") return es_sip_fd_meta_title(inputs)
	if (locale === "de") return de_sip_fd_meta_title(inputs)
	if (locale === "nl") return nl_sip_fd_meta_title(inputs)
	if (locale === "fr") return fr_sip_fd_meta_title(inputs)
	if (locale === "it") return it_sip_fd_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_sip_fd_meta_title(inputs)
	if (locale === "pt") return pt_sip_fd_meta_title(inputs)
	if (locale === "ja") return ja_sip_fd_meta_title(inputs)
	return zh_sip_fd_meta_title(inputs)
};